import src from "../../../assets/logo.svg";
import { Asset } from "../Asset";

export const Logo = Asset(src);
